import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import { t } from '../../../../../i18n';

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', url } = payload;
    const api = new ApiInstance(url, '');

    const result = yield call(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200 && result?.data?.records) {
      const { group, records, totalCount, filteredCount, sortable_columns } = result.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          group,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    } else {
      yield put(actions.loadDataError({ error: result?.messages?.[0] }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* downloadCSV({ payload }) {
  try {
    const api = new ApiInstance(payload.url);
    const result = yield call(sendRequest, api.get, { contentTypeHeader: 'csv' }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      const link = document.createElement('a');
      link.href = result.data.fileBlobUrl;
      link.target = '_blank';
      link.download = result.data.fileName || `price_list-${Math.random().toString(36).slice(-5)}.csv`;
      link.click();
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.exported_successfully', {
            item: t('dash.units.unit.priceList.price_list_header'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
  yield all([takeEvery(actions.DOWNLOAD_CSV, downloadCSV)]);
}
